import { render, staticRenderFns } from "./Bullets.vue?vue&type=template&id=99aaa852&"
import script from "./Bullets.vue?vue&type=script&lang=js&"
export * from "./Bullets.vue?vue&type=script&lang=js&"
import style0 from "./Bullets.vue?vue&type=style&index=0&id=99aaa852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports